import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: '#89BD23',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  icon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#89BD23',
  },
  text: {
    color: '#89BD23',
    fontFamily: '"Inter", sans-serif',
    fontWeight: 600,
  },
  loginContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    textAlign: 'center',
    marginTop: '-90px',
    marginBottom: '30px',
    color: '#89BD23',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
})
